// ===============================
// pages/Contact.jsx
// ===============================

import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-page">

      {/* PAGE BANNER */}
      <div className="page-banner">
        <h1>Contact Us</h1>
      </div>

      <div className="container contact-wrapper">

        {/* LEFT SIDE */}
        <div className="contact-info">

          <span className="contact-tag">
            GET IN TOUCH
          </span>

          <h2>
            We'd Love To Hear From You
          </h2>

          <p>
            Have questions about products,
            shipping, or orders? Our team is
            ready to help you anytime.
          </p>

          {/* INFO BOXES */}

          <div className="info-box">

            <div className="info-icon">
              <i className="fa-solid fa-location-dot"></i>
            </div>

            <div>
              <h4>Address</h4>

              <p>
                123 Shopping Street,
                New Delhi, India
              </p>
            </div>

          </div>

          <div className="info-box">

            <div className="info-icon">
              <i className="fa-solid fa-phone"></i>
            </div>

            <div>
              <h4>Phone</h4>

              <p>
                +91 98765 43210
              </p>
            </div>

          </div>

          <div className="info-box">

            <div className="info-icon">
              <i className="fa-solid fa-envelope"></i>
            </div>

            <div>
              <h4>Email</h4>

              <p>
                support@sabmilega.com
              </p>
            </div>

          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="contact-form-box">

          <form className="contact-form">

            <div className="input-row">

              <input
                type="text"
                placeholder="First Name"
              />

              <input
                type="text"
                placeholder="Last Name"
              />

            </div>

            <input
              type="email"
              placeholder="Email Address"
            />

            <input
              type="text"
              placeholder="Subject"
            />

            <textarea
              rows="6"
              placeholder="Write your message..."
            ></textarea>

            <button type="submit">
              Send Message
            </button>

          </form>

        </div>

      </div>

      {/* MAP SECTION */}
      <div className="map-section">

        <iframe
          title="map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224345.83923006058!2d77.06889944999999!3d28.5272803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d1d1b0b6d7f3f%3A0x9b74c2bfa7f4b2a7!2sNew%20Delhi!5e0!3m2!1sen!2sin!4v1716538579846!5m2!1sen!2sin"
          loading="lazy"
          allowFullScreen=""
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>

      </div>

    </div>
  );
};

export default Contact;